window.addEventListener("load", function() {
  // Create and mount stripe elements form
  const stripe = Stripe(window.STRIPE_PUBLISHABLE_KEY); // eslint-disable-line no-undef
  const elements = stripe.elements();
  const card = elements.create("card");

  card.mount("#card-element");

  // Listen for changes and print errors if needed
  card.addEventListener("change", ({ error }) => {
    const displayError = document.getElementById("card-errors");
    if (error) {
      displayError.textContent = error.message;
    } else {
      displayError.textContent = "";
    }
  });

  // Event listener for form submission to check if there are errors
  const form = document.getElementById("donation-form");

  form.addEventListener("submit", async event => {
    let stripeTokenInput = form.querySelector('input[name="stripe_token"]')
    if (stripeTokenInput && stripeTokenInput.value) return

    event.preventDefault();
    event.stopPropagation()
    const submitInput = form.querySelector('input[type="submit"]');

    submitInput.disabled = true;
    submitInput.value = 'Processing...';

    const { token, error } = await stripe.createToken(card);

    if (error) {
      const errorElement = document.getElementById("card-errors");
      errorElement.textContent = error.message;
      submitInput.disabled = false;
      submitInput.value = 'Donate';
    } else {
      stripeTokenHandler(token);
    }
  });

  // Submit stripe token
  const stripeTokenHandler = token => {
    const form = document.getElementById("donation-form");
    const hiddenInput = document.getElementsByName("stripe_token")[0];
    hiddenInput.setAttribute("value", token.id);
    form.requestSubmit();
  };
});
